export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',
	rangeToggle: 'inline-flex items-center gap-3xs rounded-md border border-subtle bg-white p-3xs',
	rangeBtn: 'rounded-md px-sm py-3xs text-[12px] font-medium transition-colors',
	rangeBtnActive: 'bg-grey-600 text-white',
	rangeBtnIdle: 'text-subtle hover:bg-grey-25',
	statGrid: 'grid grid-cols-2 gap-x-lg gap-y-md border-y border-subtle py-lg md:grid-cols-5',
	stat: 'relative flex flex-col gap-2xs',
	statLabel: 'flex items-center gap-3xs text-[11px] font-medium tracking-wide text-subtle',
	statValue: 'text-[26px] font-semibold leading-none tracking-tight tabular-nums text-default',
	statValueBrand: 'text-[26px] font-semibold leading-none tracking-tight tabular-nums text-purple-700',
	statSpark: 'absolute right-0 top-0 h-xl w-[48px] opacity-60',
	deltaUp: 'text-[11px] font-medium tabular-nums text-success',
	deltaDown: 'text-[11px] font-medium tabular-nums text-error',
	deltaFlat: 'text-[11px] font-medium tabular-nums text-subtle',
	sectionH: 'text-[15px] font-semibold leading-tight tracking-tight text-default',
	sectionSub: 'mt-3xs text-[12px] text-subtle',
	tableHeader: 'text-[10px] font-medium uppercase tracking-wider text-subtle',
	tableCell: 'text-[13px] text-default',
	tableCellMuted: 'text-[13px] text-subtle',
	userAvatar:
		'inline-flex h-xl w-xl shrink-0 items-center justify-center rounded-full border border-subtle bg-grey-25 text-[10px] font-semibold leading-none text-default',
	statusActive: 'inline-flex items-center gap-3xs text-[12px] text-default',
	statusClosed: 'inline-flex items-center text-[12px] text-subtle',
	statusHandoff:
		'inline-flex items-center gap-3xs rounded-md bg-surface-warning px-2xs py-3xs text-[11px] font-medium leading-none text-warning',
	statusError:
		'inline-flex items-center gap-3xs rounded-md bg-surface-error px-2xs py-3xs text-[11px] font-medium leading-none text-error',
	dotSuccess: 'inline-block h-2xs w-2xs rounded-full bg-green-500',
	dotDanger: 'inline-block h-2xs w-2xs rounded-full bg-red-600',
	dotMuted: 'inline-block h-2xs w-2xs rounded-full bg-grey-400',

	statusStrip: 'grid grid-cols-1 gap-md border-b border-subtle pb-lg sm:grid-cols-2 lg:grid-cols-4',
	statusCell: 'flex flex-col gap-2xs rounded-lg border border-subtle bg-white px-md py-sm',
	statusCellLabel: 'flex items-center gap-3xs text-[11px] font-medium uppercase tracking-wider text-subtle',
	statusCellBig: 'flex items-center gap-2xs text-[15px] font-semibold leading-tight text-default',
	statusCellSub: 'text-[11px] leading-snug text-subtle',

	card: 'flex flex-col gap-sm rounded-lg border border-subtle bg-white px-md py-sm',
	attentionItem:
		'flex flex-wrap items-center gap-2xs rounded-md px-2xs py-2xs text-[12px] transition-colors hover:bg-grey-25',
	attentionItemStatic: 'flex flex-wrap items-center gap-2xs rounded-md px-2xs py-2xs text-[12px]',
	attentionTitle: 'font-medium text-default',
	attentionTime: 'tabular-nums text-subtle',
	attentionWarn:
		'inline-flex items-center gap-3xs rounded-md bg-surface-warning px-2xs py-3xs text-[10px] font-medium leading-none text-warning',

	pauseTogglePaused:
		'inline-flex items-center gap-3xs rounded-md border border-subtle px-xs py-3xs text-[12px] font-medium text-default transition-colors hover:bg-grey-25',
	pauseToggleRunning:
		'inline-flex items-center gap-3xs rounded-md border border-red-200 bg-red-50 px-xs py-3xs text-[12px] font-medium text-error transition-colors hover:bg-red-100',
	pauseIcon: 'h-[12px] w-[12px]',
	pausePanel: 'mt-2xs flex flex-col gap-2xs rounded-md border border-subtle bg-grey-25/50 p-xs',
	pauseLabel: 'text-[11px] font-medium text-subtle',
	pauseTextarea:
		'min-h-[64px] rounded-md border border-subtle bg-white px-xs py-2xs text-[12px] text-default focus:border-action-primary focus:outline-none focus:ring-2 focus:ring-action-primary/15',
	pauseError: 'text-[11px] leading-snug text-error',
	pauseActions: 'flex justify-end gap-2xs',
	pauseCancel:
		'rounded-md border border-subtle px-xs py-3xs text-[12px] text-default transition-colors hover:bg-grey-25',
	pauseConfirm:
		'inline-flex items-center gap-3xs rounded-md bg-purple-600 px-xs py-3xs text-[12px] font-medium text-white transition-colors hover:bg-purple-700 disabled:opacity-50',
	pauseSpinner: 'h-[12px] w-[12px] animate-spin',
};
